<template>
  <main>
    <div class="container-fluid message page-note">
      <TopTemplate>
        <template #left-element>
          <h3>{{ $t("common.bulletinNotes") }}</h3>
        </template>
      </TopTemplate>
      <nav class="mb-2">
        <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
          <button
            class="nav-link"
            id="nav-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-home"
            :class="{active: isReceved}"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
            key="1"
            @click="isReceved = true"
          >
            {{ $t("common.notesList") }}
          </button>

          <button
            class="nav-link"
            id="nav-home-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-home"
            :class="{active: !isReceved}"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
            key="1"
            @click="isReceved = false"
          >
            {{ $t("common.bulletinList") }}
          </button>
        </div>
        <div class="content-tabs"></div>
      </nav>

      <div class="search-date-wrapper search-filter-wrapper" :class="{borderNan: !showFil}">
        <div class="col-md-11 search searchTeacher">
          <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshClasse()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>
        <div class="date-wrapper filter-wrapper" @click="showFilter()">
          <span>{{ $t("barFiltre.filtre") }}</span>
        </div>
      </div>
      <div v-if="showFil" class="row container-select container-filter">
        <div class="col-md-12">
          <div class="reset_student" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
        <div class="col-md-12">
          <p class="filter_critere">{{ $t("common.c_recherche") }}</p>
        </div>

        <div class="col-md-6 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.type_id"
            :options="Levels"
            :searchable="true"
            placeholder="Niveau"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="selectFilter($event, 'level')"
          >
            <template #no-options="{}">
              {{ $t("common.emptysearchCourse") }}
            </template>
          </v-select>
        </div>
        <div class="col-md-6 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.class_id"
            :options="classes"
            placeholder="Classe"
            :searchable="true"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="selectFilter($event, 'class')"
          >
            <template #no-options="{}">
              {{ $t("common.emptySystem") }}
            </template>
          </v-select>
        </div>
      </div>
      <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table teacher table-note" v-if="!loading && classList.length > 0">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <tr class="row">
                      <th class="col-md-4">{{ $t("notes.tab.class") }}</th>
                      <th class="col-md-4">{{ $t("notes.tab.annee") }}</th>
                      <th class="col-md-4 view">{{ $t("common.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="ele in classList" :key="ele.id + 'class'" class="row">
                      <td class="col-md-4">
                        <p class="classe-title">{{ ele.name }}</p>
                      </td>
                      <td class="col-md-4">
                        <p>{{ ele.school_year.name }}</p>
                      </td>
                      <td class="col-md-4 action">
                        <div class="espace_height">
                          <p>
                            <a class="success_msg name_propre" @click="navigateToDetailsPage(ele.id)">
                              <i class="icon-eyes">
                                <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                              </i>
                            </a>
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-md-12 modal_dis">
                  <div class="col-md-12">
                    <div class="table__wrapper__pagination-wrapper">
                      <div class="pagination">
                        <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getListClass" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!loading && !classList.length" class="block-no-data">
        <p>{{ $t("common.noData") }}</p>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import NoteService from "../../services/note.service";
import vSelect from "vue-select";
import {mapGetters} from "vuex";
export default {
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      pagination: {},
      last_page: null,
      showFil: false,
      params: {
        q: "",
        limit: 10,
        page: 1,
        order: false,
        type_id: null,
        class_id: null,
        hasfilter: false,
      },
      isReceved: true,
      classList: [],
      Levels: [],
      classes: [],
      level_id: [],
      passageYears: null,
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.params.type_id = null;
        this.params.class_id = null;
        this.params.q = "";
        this.level_id = [];
        this.passageYears = val.id;
        this.classes = []
        this.getFilterListClass();
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "bulletinsList") {
      next((vm) => {
        vm.isReceved = false;
      });
    } else {
      next((vm) => {
        vm.isReceved = true;
      });
    }
  },
  mounted() {
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.getFilterListClass();
    }
  },
  methods: {
    async getListClass(page) {
      try {
        this.loading = true;
        if (page) {
          this.params.page = page;
        }
        const config = {
          params: {
            q: this.params.q,
            limit: this.params.limit,
            page: this.params.page,
            order: this.params.order,
            class_id: this.params.class_id,
            type_id: this.level_id.length ? this.level_id : null,
            hasfilter: this.params.hasfilter || null,
            school_year: this.passageYears,
          },
        };
        const res = await NoteService.getClassList(config);
        this.classList = res.data.data;
        this.pagination = this.makePagination(res.data.meta, res.data.links);
        this.last_page = res.data.meta.last_page;    
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
        this.params.hasfilter = false;
      }
    },
    async getFilterListClass() {
      this.loading = true;
      const config = {
        params: {
          school_year: this.passageYears,
        },
      };
      try {
        const res = await NoteService.getFilterClassList(config);
        this.Levels = res.data.data.types;
        await this.getListClass();
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
      }
    },
    async selectFilter(ev, select) {
      this.level_id = select === "level" ? (ev ? [ev] : []) : this.level_id;
      this.params.class_id = select === "level" && !ev ? null : this.params.class_id;
      this.classes = select === "level" ? this.Levels.find((ele) => ele.id === ev)?.classe : this.classes;
      await this.getListClass();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    async resetFilter() {
      this.params.type_id = null;
      this.params.class_id = null;
      this.params.q = "";
      this.level_id = [];
      await this.getFilterListClass();
    },
    searshClasse: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.getListClass();
      }
    }, 200),
    navigateToDetailsPage(id) {
      this.$router.push({name: this.isReceved ? "DomainList" : "bulletinsList", params: {id: id}});
    },
  },
};
</script>

<style lang="scss" scoped></style>
